module.exports = __webpack_public_path__ + "img/feather-icon.bfdea059.svg";